var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5,
    width: 29,
    height: 29,
    rx: 14.5,
    transform: "rotate(-90 0.5 29.5)",
    fill: "#F9FAFE",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0096 18.0621C15.2141 18.0625 15.4122 17.9913 15.5696 17.8609L20.8196 13.4859C20.9983 13.3374 21.1107 13.1239 21.132 12.8926C21.1534 12.6612 21.0819 12.4308 20.9334 12.2521C20.7849 12.0734 20.5715 11.9611 20.3401 11.9397C20.1087 11.9184 19.8783 11.9899 19.6996 12.1384L15.0096 16.0584L10.3196 12.2784C10.2301 12.2057 10.1272 12.1514 10.0166 12.1187C9.90607 12.0859 9.79014 12.0753 9.67549 12.0875C9.56084 12.0997 9.44973 12.1345 9.34855 12.1897C9.24736 12.245 9.1581 12.3197 9.0859 12.4096C9.00576 12.4996 8.94507 12.6051 8.90763 12.7197C8.87019 12.8342 8.8568 12.9552 8.8683 13.0751C8.8798 13.195 8.91594 13.3113 8.97446 13.4166C9.03299 13.5219 9.11263 13.614 9.2084 13.6871L14.4584 17.9134C14.6203 18.0232 14.8144 18.0756 15.0096 18.0621Z",
    fill: "#0D8ECA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5,
    width: 29,
    height: 29,
    rx: 14.5,
    transform: "rotate(-90 0.5 29.5)",
    stroke: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoDown);
export default __webpack_public_path__ + "static/media/go-down.ba0d303230a3852c8106483e889d41eb.svg";
export { ForwardRef as ReactComponent };